import { createStyles } from "@material-ui/core/styles";
import { successColor, warningColor } from "../../styles/mui/theme";

export const muiStylesValidationState = () =>
  createStyles({
    icons: {
      fontSize: "10px",
      marginRight: "5px",
    },
    success: {
      color: successColor,
    },
    error: {
      color: warningColor,
    },
  });
